/**
 * Labstep
 *
 * @module components/Organization/Settings/Mfa
 * @desc Updated mfa organization settings
 */

import { OrganizationPremiumFeatureToggle } from 'labstep-web/components/Organization/PremiumFeatureToggle';
import { Checkbox } from 'labstep-web/core/Checkbox';
import type React from 'react';
import type { OrganizationSettingsMfaProps } from './types';

export const OrganizationSettingsMfa: React.FC<
  OrganizationSettingsMfaProps
> = ({ organization }) => {
  if (!organization.hasFeatureEnabled('2fa')) {
    return <OrganizationPremiumFeatureToggle premiumFeature="2fa" />;
  }
  if (organization.is_saml_enabled) {
    return (
      <p>
        {organization.name} has enabled Saml SSO. Please use your SAML
        provider for two factor authentication.
      </p>
    );
  }
  return <Checkbox toggle checked disabled />;
};
